import React, { type ReactNode } from "react";
import type { BaseProps } from "@purpur/common-types";
import c from "classnames/bind";

import styles from "./card-content-container.module.scss";

const cx = c.bind(styles);

const rootClassName = "purpur-card-content-container";

type CardContentContainerProps = Omit<BaseProps, "children"> & {
  /**
   * The child elements of the content container (React.ReactNode)
   */
  children: ReactNode;
  /**
   * Flag to remove the top padding
   */
  isFooter?: boolean;
  fullHeight?: boolean;
  gapSize?: "sm" | "md" | "lg" | "xl";
};

export const CardContentContainer = ({
  ["data-testid"]: dataTestId = "purpur-card-content-container",
  children,
  className,
  isFooter = false,
  fullHeight = false,
  gapSize = "md",
  ...props
}: CardContentContainerProps) => (
  <div
    className={cx([
      rootClassName,
      className,
      `${rootClassName}--gap-size--${gapSize}`,
      {
        [`${rootClassName}--full-height`]: fullHeight,
        [`${rootClassName}--footer`]: isFooter,
      },
    ])}
    data-testid={dataTestId}
    {...props}
  >
    {children}
  </div>
);
